import { render } from "./PpcSbStrategies.vue?vue&type=template&id=123be2da&scoped=true"
import script from "./PpcSbStrategies.vue?vue&type=script&lang=js"
export * from "./PpcSbStrategies.vue?vue&type=script&lang=js"

import "./PpcSbStrategies.vue?vue&type=style&index=0&id=123be2da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123be2da"]])

export default __exports__